import { render, staticRenderFns } from "./riskAssessmentUploadDialog.vue?vue&type=template&id=cda9ee6a"
import script from "./riskAssessmentUploadDialog.vue?vue&type=script&lang=js"
export * from "./riskAssessmentUploadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports